export default {
  newWindow: 'Opens in new window',
}
